var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeCl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.3 20",
    style: {
      enableBackground: "new 0 0 28.3 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.7,3.2C27.4,2,26.4,1,25.2,0.7c-2.2-0.6-11-0.6-11-0.6s-8.8,0-11,0.6C1.9,1,0.9,2,0.6,3.2 C0.2,5.4,0,7.7,0,10c0,2.3,0.2,4.6,0.6,6.8c0.3,1.2,1.3,2.2,2.5,2.5c2.2,0.6,11,0.6,11,0.6s8.8,0,11-0.6c1.2-0.3,2.2-1.3,2.5-2.5 c0.4-2.3,0.6-4.6,0.6-6.8C28.3,7.7,28.1,5.4,27.7,3.2 M11.2,14.2V5.8l7.4,4.2L11.2,14.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCl);
export default __webpack_public_path__ + "static/media/youtube_cl.028d86e2dba37e232bbccc2ee9ba4981.svg";
export { ForwardRef as ReactComponent };